export const headerJumboText = {
    quote: {
        header: "Talk is cheap,<br/>show me the code.",
        author: "Linus Torvalds",
        PolishLang: {
            header: "Gadanina jest tania,<br/>pokaż mi kod",
        }
    },
    a: {
        header: "If you wish, you can check my GitHub repositories.",
        href: "https://github.com/pavdevuk",
        PolishLang: {
            header: "Jeśli chcesz, przejrzyj moje repozytoria na GitHub",
        }
    }
}